export default (siteName) => [
    {
        path: 'project',
        name: 'project',
        component: () => import('../../components/dashboard/Project/ProjectPage.vue'),
        meta: {
            title: `專案${siteName}`,
            activeMenu: 'project',
        },
    },
    {
        path: 'project/add',
        name: 'project-add',
        component: () => import('../../components/dashboard/Project/ProjectEditPage.vue'),
        meta: {
            title: `新增專案${siteName}`,
            activeMenu: 'project',
        },
    },
    {
        path: 'project/:sno',
        name: 'project-detail',
        component: () => import('../../components/dashboard/Project/ProjectPage.vue'),
        meta: {
            title: `專案細節${siteName}`,
            activeMenu: 'project',
        },
    },
    {
        path: 'project/:sno/edit/',
        name: 'project-edit',
        component: () => import('../../components/dashboard/Project/ProjectEditPage.vue'),
        meta: {
            title: `編輯專案${siteName}`,
            activeMenu: 'project',
        },
    },
];
